import type { Location } from './types.js';

export const sumidaParkLocations: Location[] = [
  {
    "id": "pin-1775971057744",
    "number": 1,
    "name": "Sumida red sakura",
    "nameJa": "",
    "description": "",
    "x": 52.9,
    "y": 75,
    "mapsUrl": "https://maps.app.goo.gl/5dkeuRN6sVXaXyv49",
    "tip": "Một trong những địa điểm chụp hoa anh đào hồng nổi bật gần Asakusa. Hoa thường đẹp nhất vào khoảng hai tuần cuối tháng 3.\nDù chỉ có một vài cây, nhưng vẫn có thể tạo ra nhiều góc chụp đa dạng nhờ màu sắc nổi bật và bố cục xung quanh.\nTừ chùa Sensoji có thể đi bộ đến đây trong khoảng 10 phút.",
    "allowNight": false,
    "allowSakura": true,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973692/kra-asakusa/Sumida/1/drive_mB_8ll-V_1775973692.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973301/kra-asakusa/Sumida/1/drive_4t8PW3eb_1775973300.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973230/kra-asakusa/Sumida/1/drive_-oV_e3kN_1775973230.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973695/kra-asakusa/Sumida/1/drive_5sxpyfLZ_1775973694.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973365/kra-asakusa/Sumida/1/drive_8lmKDWG1_1775973365.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973303/kra-asakusa/Sumida/1/drive_8Tku_R-m_1775973302.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973297/kra-asakusa/Sumida/1/drive_9puHUwfH_1775973296.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973261/kra-asakusa/Sumida/1/drive_d4FMfiF6_1775973260.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973231/kra-asakusa/Sumida/1/drive_DhFkMXkh_1775973231.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973298/kra-asakusa/Sumida/1/drive_fgStuOQB_1775973298.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973228/kra-asakusa/Sumida/1/drive_IPmzeELs_1775973227.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973367/kra-asakusa/Sumida/1/drive_rL6huOHY_1775973366.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973262/kra-asakusa/Sumida/1/drive_tj8DR2bX_1775973262.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973258/kra-asakusa/Sumida/1/drive_tQz8JY-X_1775973258.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973257/kra-asakusa/Sumida/1/drive_yGS9VC1f_1775973255.jpg"
    ],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "One of the standout pink cherry blossom spots near Asakusa. The blossoms are usually at their best in the last two weeks of March.\nThere are only a few trees, but their bold colour and the surroundings still give you plenty of different angles.\nIt is about a 10-minute walk from Sensoji Temple."
    }
  },
  {
    "id": "pin-1775971623723",
    "number": 2,
    "name": "Skytree sakura view",
    "nameJa": "",
    "description": "",
    "x": 48.6,
    "y": 33,
    "mapsUrl": "https://maps.app.goo.gl/PTN2gUPHbQqopAkK8",
    "tip": "Một trong những góc chụp mang tính biểu tượng vào mùa hoa anh đào, có thể chụp xuyên suốt mùa nhưng đẹp nhất vào khoảng hai tuần cuối tháng 3.\nVào buổi sáng, do ánh sáng từ phía sau nên gương mặt dễ bị tối; cần thêm ánh sáng hỗ trợ để đạt hiệu quả tốt hơn. Thời điểm đẹp nhất là khoảng 2–3 giờ chiều, khi ánh sáng chiếu trực diện giúp gương mặt sáng và rõ hơn.\nTrong mùa sakura, khu vực này thường khá đông và có thể cần chờ để chụp.",
    "allowNight": false,
    "allowSakura": true,
    "allowMomiji": false,
    "allowHot": true,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973629/kra-asakusa/Sumida/2/drive_wkrfEnuO_1775973627.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776216246/kra-asakusa/Sumida/2/drive_zwYS96cG_1776216245.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973634/kra-asakusa/Sumida/2/drive_rVIXBIwH_1775973634.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776215971/kra-asakusa/Sumida/2/drive_prg6WySm_1776215970.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775974106/kra-asakusa/Sumida/2/drive_u_k_gR24_1775974105.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775974104/kra-asakusa/Sumida/2/drive_F_NLDWBc_1775974103.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973632/kra-asakusa/Sumida/2/drive_LVgz6XNh_1775973630.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973649/kra-asakusa/Sumida/2/drive_ME50kAou_1775973647.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776215967/kra-asakusa/Sumida/2/drive_VGtcqkJj_1776215965.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973652/kra-asakusa/Sumida/2/drive_W0OV9ehq_1775973650.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973794/kra-asakusa/Sumida/2/drive_VphmRB1z_1775973793.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973792/kra-asakusa/Sumida/2/drive_-09JVhlS_1775973790.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776216314/kra-asakusa/Sumida/2/drive_x99fVo6g_1776216312.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1776215968/kra-asakusa/Sumida/2/drive_ZmJKptGT_1776215968.jpg"
    ],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "One of the iconic cherry blossom shots. You can shoot here all season, but it is best in the last two weeks of March.\nIn the morning the light comes from behind, so faces tend to look dark and you will need extra light. The best time is around 2–3 pm, when the light hits you head-on and faces look bright and clear.\nDuring sakura season this spot gets crowded and you may need to wait your turn."
    }
  },
  {
    "id": "pin-1775971663656",
    "number": 3,
    "name": "Sumida Park",
    "nameJa": "",
    "description": "",
    "x": 69.8,
    "y": 70,
    "mapsUrl": "https://maps.app.goo.gl/R4Da3xXSHYfGmpWv7",
    "tip": "Công viên Sumida là một trong những địa điểm chụp đẹp nhất vào mùa hoa anh đào. Thường vào tháng 4, hoa anh đào trắng nở rộ, tạo nên khung cảnh rất đặc trưng.\nTại đây có thể chụp cùng hoa anh đào với tháp Skytree phía sau, tạo nên sự kết hợp giữa thiên nhiên và biểu tượng hiện đại của Tokyo.\nKhu vực này cũng có nhiều góc chụp đa dạng trong mùa sakura.",
    "allowNight": false,
    "allowSakura": true,
    "allowMomiji": false,
    "allowHot": false,
    "photoOrder": [
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973317/kra-asakusa/Sumida/3/drive_bl83ngMk_1775973317.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973320/kra-asakusa/Sumida/3/drive_IGloEp8f_1775973320.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973715/kra-asakusa/Sumida/3/drive_lKkVyDDN_1775973715.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973153/kra-asakusa/Sumida/3/drive__trtg1Wl_1775973151.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973146/kra-asakusa/Sumida/3/drive_dvAgUeR7_1775973146.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973314/kra-asakusa/Sumida/3/drive_edOziIck_1775973314.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973148/kra-asakusa/Sumida/3/drive_Ko4JBB8k_1775973148.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973144/kra-asakusa/Sumida/3/drive_NJwYr51H_1775973143.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973315/kra-asakusa/Sumida/3/drive_NYDZu8nr_1775973315.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973319/kra-asakusa/Sumida/3/drive_V9ELbeUv_1775973318.jpg",
      "https://res.cloudinary.com/dnmzhwxzw/image/upload/v1775973718/kra-asakusa/Sumida/3/drive_yFXxS0aG_1775973717.jpg"
    ],
    "hiddenPhotos": [],
    "isShop": false,
    "photos": [],
    "tipTranslations": {
      "en": "Sumida Park is one of the most beautiful photo spots in cherry blossom season. White cherry blossoms are usually in full bloom in April, a truly signature scene.\nHere you can shoot the blossoms with Tokyo Skytree behind you, mixing nature with Tokyo's modern icon.\nThere are plenty of different angles in this area during sakura season."
    }
  }
];
